import { NSButton, NSButtonProps } from "./NSButton";
import Style from "./NSButtonGreen.module.css";

export function NSButtonGreen(props: NSButtonProps) 
{
	let classList = []
	if (props.classList)
		classList.push(...props.classList);
	classList.push(Style.ns_button_green);

	return <NSButton
		{...props}
		classList={classList}
	/>;
}